import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  class: "card mb-5 mb-xl-5",
  id: "kt_profile_details_view"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "card-header cursor-pointer" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "card-title m-0" }, [
    /*#__PURE__*/_createElementVNode("h3", { class: "fw-bolder m-0" }, "Weather")
  ])
], -1)
const _hoisted_3 = { class: "card-body p-9" }
const _hoisted_4 = { class: "row mb-7" }
const _hoisted_5 = { id: "chart" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_apexchart = _resolveComponent("apexchart")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("div", _hoisted_5, [
          _createVNode(_component_apexchart, {
            ref: "chart",
            type: "area",
            height: "450",
            options: _ctx.chartOptions,
            series: _ctx.series
          }, null, 8, ["options", "series"])
        ])
      ])
    ])
  ]))
}